/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetReloadAccountBalanceConfigResult } from '../../models/get-reload-account-balance-config-result';

export interface GetReloadAccountBalanceConfig$Params {
  SiteName?: string;
}

export function getReloadAccountBalanceConfig(
  http: HttpClient,
  rootUrl: string,
  params?: GetReloadAccountBalanceConfig$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetReloadAccountBalanceConfigResult>> {
  const rb = new RequestBuilder(rootUrl, getReloadAccountBalanceConfig.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetReloadAccountBalanceConfigResult>;
    }),
  );
}

getReloadAccountBalanceConfig.PATH = '/Payments/reload-account-balance-config';
